import * as XLSX from 'xlsx';

const API = "/api/empleados"; 

export const getReporteVentasEmpleados = async (desde, hasta, usuario = '') => {
  try {
    let url = `${API}?desde=${desde}&hasta=${hasta}`;
    if (usuario) {
      url += `&usuario=${encodeURIComponent(usuario)}`;
    }
    
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error al consultar rendimiento de empleados (Código: ${response.status})`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(error.message);
  }
};

export const exportarEmpleadosExcel = (datos, desde, hasta) => {
  try {
    if (!datos || datos.length === 0) {
      throw new Error("No hay registros de ventas para el filtro seleccionado.");
    }

    const datosFormateados = datos.map((v) => ({
      "ID Venta": v.venta_id,
      "Colaborador / Empleado": v.empleado,
      "Fecha y Hora": v.fecha_completa,
      "Estado de Venta": v.estado,
      "Monto Total (S/)": Number(v.total)
    }));

    const ventasEfectivas = datos.filter(v => !v.estado.toUpperCase().includes('ANULADA'));
    const sumaTotalVendido = ventasEfectivas.reduce((acc, v) => acc + Number(v.total), 0);

    datosFormateados.push({ "ID Venta": "", "Colaborador / Empleado": "", "Fecha y Hora": "", "Estado de Venta": "", "Monto Total (S/)": null });

    datosFormateados.push({
      "ID Venta": "RESUMEN",
      "Colaborador / Empleado": `Periodo: ${desde} al ${hasta}`,
      "Fecha y Hora": `Total Ventas: ${datos.length}`,
      "Estado de Venta": "Total Efectivo:",
      "Monto Total (S/)": Number(sumaTotalVendido.toFixed(2))
    });

    const hoja = XLSX.utils.json_to_sheet(datosFormateados);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Reportes Ventas Empleado");

    const nombreArchivo = `Reportes_Ventas_Personal_${desde}_a_${hasta}.xlsx`;
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
        if (isIOS) {
            // En iOS descargas directo usando la gestión de archivos nativa de Safari
            XLSX.writeFile(libro, nombreArchivo);
        } else {
            // En Android / Escritorio, generamos el buffer y forzamos la descarga con su nombre real
            const excelBuffer = XLSX.write(libro, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
            const url = URL.createObjectURL(blob);
            
            // Creamos un elemento 'a' invisible en memoria
            const link = document.createElement('a');
            link.href = url;
            link.download = nombreArchivo; // 👈 Aquí le inyectamos el nombre real del reporte
            
            // Añadimos al documento, hacemos click y removemos inmediatamente
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Limpiamos el objeto URL de la memoria de manera segura
            setTimeout(() => URL.revokeObjectURL(url), 250); 
        }
        
  } catch (error) {
    throw new Error("Error al generar el Excel de empleados: " + error.message);
  }
};